import React, { useRef, useEffect } from 'react';
import './Dropdown.css';

const Dropdown = ({ items, onClose, placement = 'bottom-right' }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div
      ref={containerRef}
      className={`dropdown-menu ${placement === 'top-left' ? 'top-left' : ''}`}
    >
      {items.map((item, i) => (
        <div
          key={i}
          className="dropdown-item"
          onClick={() => {
            item.onClick();
            onClose();
          }}
          style={item.style || {}}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
};

export default Dropdown;
